import React, { useState } from "react";
import {
  Container,
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
} from "reactstrap";
import classnames from "classnames";
import Footer from "../../components/user/Footer";
import ProductDetail from "../../components/user/ProductDetail";
import ProductDescription from "../../components/user/ProductDescription";
import Review from "../../components/user/Review";
import "../user/style.css";

function Product() {
  const [currentActiveTab, setCurrentActiveTab] = useState("1");

  const toggle = (tab) => {
    if (currentActiveTab !== tab) setCurrentActiveTab(tab);
  };

  return (
    <div className="pt-3">
      <div className="bg_breadcrumb">
        <p className="fs-3 fw-bold t-white text-center t-breadcrumb">Product</p>
      </div>

      <Container className="py-5 px-5">
        <ProductDetail />

        <div className="tab_product mt-5">
          <Nav tabs>
            <NavItem>
              <NavLink
                className={classnames({
                  active: currentActiveTab === "1",
                })}
                onClick={() => {
                  toggle("1");
                }}
              >
                Product Description
              </NavLink>
            </NavItem>

            <NavItem>
              <NavLink
                className={classnames({
                  active: currentActiveTab === "2",
                })}
                onClick={() => {
                  toggle("2");
                }}
              >
                Reviews
              </NavLink>
            </NavItem>
          </Nav>
          <TabContent activeTab={currentActiveTab}>
            <TabPane tabId="1">
              <div className="p-3">
                <ProductDescription />
              </div>
            </TabPane>

            <TabPane tabId="2">
              <div className="p-3">
                <Review />
              </div>
            </TabPane>
          </TabContent>
        </div>
      </Container>

      <Footer />
    </div>
  );
}

export default Product;
